import { LabelsStoreAction, LabelsStoreType } from './labelsStore.types';

export const INITAL_LABEL = {
  titleDefaultViewLanguage: 'en',
  titleDefaultView1: 'IDEaL',
  titleDefaultView2: '.',
  titleDefaultView3: 'Interactive Database for Evaluation and Learning',
  titleYearsViewLanguage: 'en',
  titleYearsView1: 'IDEaL',
  titleYearsView2: '.',
  titleYearsView3: 'Annual report: 2021-2022',
  searchProject: 'Search for projects',
  region: 'Region',
  country: 'Country',
  sector: 'Sector',
  sector2: 'BMZ Priority area',
  typeOfProjectPartner: 'Type of implementing partner',
  overallRating: 'Overall rating:',
  resetFilter: 'Clear filters',
  resultsPerPage: 'Results per page',
  sortBy: 'Sort by',
  ratingDesc: 'Successful projects first',
  ratingAsc: 'Unsuccessful projects first',
  relevance: 'Relevance',
  coherence: 'Coherence',
  effectiveness: 'Effectiveness',
  efficiency: 'Efficiency',
  impact: 'Impact',
  sustainability: 'Sustainability',
  ratingProcessMoreInformationBeforeLink:
    'For more information about our rating process, please visit ',
  ratingProcessMoreInformationOnLink: 'this link',
  ratingProcessMoreInformationAfterLink: '.',
  showReport: 'Show report',
  details: 'Details',
  projectSummary: 'Project description',
  ratingNotValid: 'Select a number between 1 and 6',
  newestAsc: 'Latest evaluation first',
  oldestAsc: 'Oldest evaluation first',
  projects: 'projects',
  project: 'project',
  projectSearchInfo1: 'Your search returned',
  projectSearchInfo2: 'results',
  projectSearchInfo2Singular: 'result',
  showFilter: 'Show filters',
  backToSearchResults: 'Back to search results',
  noResults:
    'The combination of your set filters does not yield any results. Please adjust your selection.',
  noResults1: 'Unfortunately, your search for',
  noResults2: 'did not return any results.',
  searchTips: 'Search tips',
  checkSpelling: 'Make sure all words are spelled correctly.',
  tryToGeneralize: 'Try to generalize your search.',
  trySimilarRequest: 'Try using a similar search term.',
  select: 'Enter search term',
  showResults1: 'Show',
  showResults2: 'search results',
  rating: 'Rating:',
  navigateToSearchResultBefore: 'Show previous search result',
  navigateToNextSearchResult: 'Show next search result',
  projectData: 'Project data',
  projectTitle: 'Title',
  year: 'Year of evaluation',
  totalFunds: 'Total expenditure',
  sourceOfFounds: 'Source of funds',
  projectNumber: 'Project number',
  shortDescriptionTitle: 'Description',
  lessonsLearntTitle: 'Lessons learnt',
  indicatorAndAchievement: 'Goals and indicators',
  outcomeTitle: 'Outcome',
  impactTitle: 'Impact',
  indicator: 'Indicator',
  achievement: 'Achievement of objectives',
  crosslinkTitle: 'You might also be interested in',
  readNow: 'Read now',
  more: 'More',
  fullfilled: 'Achieved',
  partiallyFulfilled: 'Partly achieved',
  notFulfilled: 'Not achieved',
  tooltipTotalFunds:
    'Corresponds to the total cost of the project which may exceed the german FC contribution.',
  tooltipCoherence:
    'This criterion was only introduced in 2020 and is hence only available for few projects.',
  page1: 'Page',
  page2: 'of search results',
  firstSearchPage: 'First page of search results',
  nextSearchPage: 'Next page of search results',
  previousSearchPage: 'Previous page of search results',
  lastSearchPage: 'Last page of search results',
  downloadReportInfo1: 'Show report',
  downloadReportInfo2:
    ' in a new tab, PDF, size unknown, accessibility level unknown',
  projectsLoadingFailure: 'An error occured. Unable to load projects.',
  projectLoadingFailure: 'An error occured. Unable to load the project.',
  projectLoading404: 'The specified project was not found.',
  dropdownOptionLoadingFailure: 'Unable to load entries',
  enterSearchTerm: 'Search IDEaL',
  eraseSearchTerm: 'Erase search term',
  startSearch: 'Start search',
  noLessonsLearnt: 'No lessons learnt are available for this project.',
  noOutcome: 'No outcome-indicators are available for this project.',
  noImpact: 'No impact-indicators are available for this project.',
  tableOfContents: 'Table of contents',
  aboutIDEaLApp: 'About the IDEaL-App',
  homePage: 'Homepage',
  evaluation: 'Evaluation',
  headerTitle1: 'About us',
  headerTitle2: 'Topics',
  headerTitle3: 'Global commitment',
  headerTitle4: 'Results',
  headerTitle5: 'Transparency',
  headerTitle6: 'Service',
  headerTitle7: 'KfW Stories',
  headerTitleAddition7:
    'The digital magazine of KfW Group tells stories from all over the world',
  headerTitle8: 'KfW Group',
  headerTitleAddition8:
    'Here you can find all important information on KfW Group.',
  footerPrint: 'Print',
  footerServices: 'Services',
  footerServiceTitle1: 'Press',
  footerServiceTitle2: 'Publications',
  footerServiceTitle3: 'Newsletter',
  footerServiceTitle4: 'Contact',
  footerFollow: 'Follow us on',
  footerCopyright: 'KfW, Frankfurt am Main',
  footerSitemap: 'Sitemap',
  footerAccessibility: 'Accessibility',
  footerDataProtection: 'Data protection',
  footerImprint: 'Imprint',
  footerPictureCredits: 'Picture credits',
  footerBackToTop: 'Back to top',
  routeToKfWHomepage: 'Go to the homepage of the KfW-Entwicklungsbank',
  menu: 'Menu',
  close: 'Close',
  skipToMainContent: 'Skip to main content',
};

const labelsStore = (
  state: LabelsStoreType,
  action: LabelsStoreAction
): LabelsStoreType => {
  switch (action.type) {
    case 'INITIAL': {
      return { ...state, ...action.payload };
    }
    default:
      throw new Error();
  }
};

export default labelsStore;
